import { directive } from "vue-tippy";

// Текст считается обрезанным, когда не помещается в элемент по ширине
// (white-space: nowrap + ellipsis) или по высоте (-webkit-line-clamp).
const isOverflowing = (el) => {
    return (
        el.scrollWidth - el.clientWidth > 1 ||
        el.scrollHeight - el.clientHeight > 1
    );
};

// Что показать в подсказке: явно переданное значение (полное имя — даже если
// в разметке оно сокращено), иначе собственный текст элемента.
const resolveContent = (el) => {
    const explicit = el.__ellipsisValue;

    if (explicit !== undefined && explicit !== null && explicit !== "") {
        return String(explicit);
    }

    return (el.textContent || "").replace(/\s+/g, " ").trim();
};

const buildBinding = (el, binding) => {
    return {
        ...binding,
        value: {
            content: () => resolveContent(el),
            theme: "dark",
            arrow: true,
            delay: [200, 100],
            placement: binding.arg ?? "top",
            // Подсказку показываем только когда текст реально обрезан. Проверка
            // в момент наведения корректно учитывает ресайз окна и адаптив.
            onShow: () => isOverflowing(el),
        },
    };
};

// Глобальная директива v-ellipsis-tooltip: вешает всплывающую подсказку с полным
// текстом на элемент, который обрезается по ширине или высоте. Без значения берёт
// собственный текст элемента, со значением — переданную строку.
export const vEllipsisTooltip = {
    mounted(el, binding, vnode) {
        el.__ellipsisValue = binding.value;

        directive.mounted(el, buildBinding(el, binding), vnode);
    },

    updated(el, binding) {
        el.__ellipsisValue = binding.value;
    },

    unmounted(el) {
        directive.unmounted(el);

        delete el.__ellipsisValue;
    },
};
